import type { PropsWithChildren } from "react";
import { BuilderUI } from "@circle-react-shared/BuilderUI";

export const BuilderCanvas = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <BuilderUI.Main>
    <div className="relative [grid-area:canvas]">
      <BuilderUI.Canvas className="relative gap-3 px-6 pb-16 pt-6 [grid-area:none]">
        <BuilderUI.CanvasZoomableSize>
          <BuilderUI.CanvasCard className="h-full rounded-2xl border-0">
            {children}
          </BuilderUI.CanvasCard>
        </BuilderUI.CanvasZoomableSize>
        <BuilderUI.FullscreenPreview />
        <BuilderUI.CanvasControls className="bg-primary absolute bottom-[6.5rem] left-1/2 -translate-x-1/2 !gap-0 rounded-xl shadow-lg">
          <BuilderUI.CanvasSizeToggle />
        </BuilderUI.CanvasControls>
      </BuilderUI.Canvas>
    </div>
  </BuilderUI.Main>
);
